var _path, _rect, _path2, _rect2, _rect3, _rect4, _path3, _rect5, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMosaicLogo2021(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1552 25.2961C12.8051 26.946 15.4801 26.946 17.1299 25.2961L18.8566 23.5695L14.1426 18.8555L9.42859 23.5695L11.1552 25.2961Z",
    fill: "#F15A4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.66659,
    height: 6.66659,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 18.8564 23.5702)",
    fill: "#C25ECB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5703 18.8562L25.297 17.1295C26.9468 15.4797 26.9468 12.8047 25.297 11.1549L23.5703 9.42822L18.8563 14.1422L23.5703 18.8562Z",
    fill: "#067BBC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.66659,
    height: 6.66659,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 18.8564 14.1425)",
    fill: "#1DA4A2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.66659,
    height: 6.66659,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 14.1426 18.8563)",
    fill: "#989F8F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6.66659,
    height: 6.66659,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9.42871 23.5702)",
    fill: "#E98A1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1426 9.42798L18.8566 4.71399L17.1299 2.98733C15.4801 1.33747 12.8051 1.33747 11.1552 2.98733L9.42859 4.71399L14.1426 9.42798Z",
    fill: "#85CD94"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.66659,
    height: 6.66659,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9.42871 14.1423)",
    fill: "#ACCA56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71484 18.8562L9.42884 14.1422L4.71484 9.42822L2.98819 11.1549C1.33833 12.8047 1.33833 15.4797 2.98819 17.1295L4.71484 18.8562Z",
    fill: "#E0BF53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicLogo2021);
export default __webpack_public_path__ + "static/media/mosaic-logo-2021.3f987de26c591c01452c8f4c889350fa.svg";
export { ForwardRef as ReactComponent };